<template>
  <NavigationLink
    class="flex cursor-pointer flex-row gap-x-4 font-semibold"
    :class="$attrs.class"
    :url="route"
    :type="element"
  >
    <IconArrowBack v-if="showIconBack" :class="iconClass" />
    <h3 class="text-sm">{{ title }}</h3>
  </NavigationLink>
</template>

<script setup lang="ts">
import IconArrowBack from '~/assets/icons/icon-arrow-back.svg'
import NavigationLink from '~/components/shared/navigation/Link.vue'

withDefaults(
  defineProps<{
    showIconBack?: boolean
    title?: string
    route: string | Record<string, unknown>
    element?: string
    iconClass?: string
  }>(),
  {
    showIconBack: true,
    element: 'nuxt-link',
    iconClass: 'w-4',
  },
)
</script>
